import {Component, model} from '@angular/core';
import {DxDataGridModule, DxPopupModule} from 'devextreme-angular';
import {
  ProduitComplementaireSuppressionBloqueeDTO
} from '../../../core/dtos/produit/declinaison/complementaire/produit-complementaire-suppression-bloquee-dto';

/** Liste les produits retirés dont l'enregistrement est refusé : des effectifs y sont encore saisis. */
@Component({
  selector: 'yo-dialog-suppression-bloquee',
  templateUrl: './dialog-suppression-bloquee.component.html',
  standalone: true,
  imports: [DxPopupModule, DxDataGridModule]
})
export class DialogSuppressionBloqueeComponent {

  readonly suppressionBloqueeList = model<ProduitComplementaireSuppressionBloqueeDTO[]>([]);

  joinDateEffectif = (suppressionBloquee: ProduitComplementaireSuppressionBloqueeDTO): string =>
    suppressionBloquee.dateEffectifList.map(date => new Date(date).toLocaleDateString('fr-FR')).join(', ');

  closeDialog = (): void => this.suppressionBloqueeList.set([]);
}
